import React from 'react';
import {ES, MX, VN} from 'country-flag-icons/react/3x2';

import cls from '../components/Header/Header.module.scss'

export interface IGeo {
    key: string,
    name: string,
    icon: React.ReactNode,
    currency: string,
    language: string,
}

export const geos:IGeo[] = [
    {
        key: 'MX',
        name: 'Mexico',
        icon: <MX className={cls.flag} />,
        currency: 'MXN',
        language: 'es',
    },
    {
        key: 'ES',
        name: 'Spain',
        icon: <ES className={cls.flag} />,
        currency: 'EUR',
        language: 'es',
    },
    {
        key: 'VN',
        name: 'Vietnam',
        icon: <VN className={cls.flag} />,
        currency: 'VND',
        language: 'vn',
    },
]